"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ToggleDrawer = exports.GetTestIdMap = exports.DrawerList = exports.DrawerLink = void 0;
var DrawerMethods = _interopRequireWildcard(require("./MenuDrawer"));
var MenuDrawerStyles = _interopRequireWildcard(require("./MenuDrawerStyles"));
var _ImportedContentFragment = _interopRequireDefault(require("../ContentFragments/ImportedContentFragment"));
var _reactRouterDom = require("react-router-dom");
var _Logo = _interopRequireDefault(require("./Logo"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _debounce = require("../../utils/performance/debounce");
var _array = require("../../utils/type-checks/array");
var _boolean = require("../../utils/type-checks/boolean");
var _object = require("../../utils/type-checks/object");
var _string = require("../../utils/type-checks/string");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const merge = require("deepmerge"),
  headerRegEx = /--noHeader$/,
  DrawerLink = props => {
    const {
        className,
        isNew,
        item,
        label,
        path,
        url,
        testId
      } = props,
      linkClasses = (0, _classnames.default)({
        "navigation-mobile__drawer-link": true,
        [`${className}`]: className
      }),
      BuildAnchor = _ref => {
        let {
          linkClasses,
          testId,
          url,
          label,
          isNew
        } = _ref;
        if (!(0, _object.isObject)(window.PubSub)) {
          window.PubSub = require("pubsub-js");
        }
        return /*#__PURE__*/_react.default.createElement("a", {
          className: linkClasses,
          "data-testid": testId,
          href: url,
          onClick: () => window.PubSub.publish("navigation.mobile.close"),
          rel: "noreferrer",
          target: "_blank"
        }, label, isNew === true && /*#__PURE__*/_react.default.createElement(_material.Box, {
          component: "span",
          className: "navigation-mobile__new-indicator"
        }, "New!"));
      },
      BuildLink = _ref2 => {
        let {
          linkClasses,
          testId,
          path,
          label,
          isNew
        } = _ref2;
        return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
          className: linkClasses,
          "data-testid": testId,
          to: path
        }, label, isNew === true && /*#__PURE__*/_react.default.createElement(_material.Box, {
          component: "span",
          className: "navigation-mobile__new-indicator"
        }, "New!"));
      };
    let result = "";
    if ((0, _string.isStringOfLength)(label)) {
      if ((0, _string.isStringOfLength)(path)) {
        result = /*#__PURE__*/_react.default.createElement(BuildLink, {
          linkClasses: linkClasses,
          testId: testId,
          path: path,
          label: label,
          isNew: isNew
        });
      } else if ((0, _string.isStringOfLength)(url)) {
        result = /*#__PURE__*/_react.default.createElement(BuildAnchor, {
          linkClasses: linkClasses,
          testId: testId,
          url: url,
          label: label,
          isNew: isNew
        });
      } else if (item) {
        if ((0, _string.isStringOfLength)(item.path)) {
          result = /*#__PURE__*/_react.default.createElement(BuildLink, {
            linkClasses: linkClasses,
            testId: testId,
            path: item.path,
            label: label,
            isNew: item.isNew
          });
        } else if ((0, _string.isStringOfLength)(item.url)) {
          result = /*#__PURE__*/_react.default.createElement(BuildAnchor, {
            linkClasses: linkClasses,
            testId: testId,
            url: item.url,
            label: label,
            isNew: item.isNew
          });
        }
      }
    }
    return result;
  },
  DrawerList = props => {
    const {
        category,
        item,
        ...rest
      } = props,
      {
        bundledStyles,
        compiledStyles = {
          parentButtonStyles: {},
          fragmentStyles: {},
          listStyles: {},
          listItemStyles: {}
        },
        customTheme = {},
        fragmentId,
        logo,
        testId,
        variant
      } = rest;
    let result = "";
    if ((0, _object.isObject)(category)) {
      if ((0, _array.isArrayOfLength)(category.items)) {
        result = /*#__PURE__*/_react.default.createElement(_material.List, {
          className: "navigation-mobile__list",
          sx: compiledStyles.listStyles,
          "data-testid": testId
        }, category.items.map((item, i) => /*#__PURE__*/_react.default.createElement(_material.ListItem, {
          className: "navigation-mobile__list-item",
          key: `${item.label}_${i}`,
          sx: compiledStyles.listItemStyles
        }, /*#__PURE__*/_react.default.createElement(MenuDrawer, {
          customTheme: customTheme,
          backLabel: category.label,
          bundledStyles: merge(bundledStyles, {
            customParentButtonStyles: compiledStyles.parentButtonStyles
          }),
          drawerClassName: item.mobileClassName,
          headerPath: item.headerPath,
          isNew: item.isNew,
          item: item,
          label: item.label,
          logo: logo,
          path: item.path,
          variant: (0, _string.isStringOfLength)(item.variant) ? item.variant : variant
        }))));
      } else if ((0, _array.isArrayOfLength)(category.fragments)) {
        result = category.fragments.map((fragmentId, i) => {
          let listItem = "";
          if ((0, _string.isStringOfLength)(fragmentId)) {
            listItem = /*#__PURE__*/_react.default.createElement(_material.Box, {
              className: "navigation-mobile__fragments",
              "data-testid": testId,
              key: `${fragmentId}_${i}`,
              sx: compiledStyles.fragmentStyles
            }, /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
              id: fragmentId
            }));
          }
          return listItem;
        });
      }
    } else if ((0, _object.isObject)(item)) {
      result = /*#__PURE__*/_react.default.createElement(DrawerList, _extends({}, rest, {
        category: item
      }));
    } else if ((0, _string.isStringOfLength)(fragmentId)) {
      result = /*#__PURE__*/_react.default.createElement(_material.Box, {
        className: "navigation-mobile__fragments",
        "data-testid": testId,
        sx: compiledStyles.fragmentStyles
      }, /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
        id: fragmentId
      }));
    }
    return result;
  },
  GetTestIdMap = testId => {
    return {
      componentTestId: testId ? testId : undefined,
      buttonTestId: testId ? `${testId}_button` : undefined,
      backButtonTestId: testId ? `${testId}_back-button` : undefined,
      drawerTestId: testId ? `${testId}_drawer` : undefined,
      headingLinkTestId: testId ? `${testId}_heading-link` : undefined,
      headingTestId: testId ? `${testId}_heading` : undefined,
      listTestId: testId ? `${testId}_list` : undefined
    };
  },
  ToggleDrawer = (event, open, setter) => {
    let result = null;
    if (event && (0, _string.isStringOfLength)(event?.type) && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      result = null;
    } else if (!(0, _boolean.isBoolean)(open)) {
      result = null;
    } else {
      result = open;
      setter(open);
    }
    return result;
  };

/**
 * Menu Drawer for Mobile Navigation
 *
 * @visibleName Mobile Navigation - Menu Drawer
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.ToggleDrawer = ToggleDrawer;
exports.GetTestIdMap = GetTestIdMap;
exports.DrawerList = DrawerList;
exports.DrawerLink = DrawerLink;
const MenuDrawer = props => {
  if (!(0, _object.isObject)(window.PubSub)) {
    window.PubSub = require("pubsub-js");
  }
  const {
      anchor = "right",
      autoOpen = false,
      backLabel,
      bundledStyles = {},
      buttonClassName,
      children,
      customTheme = {},
      drawerClassName,
      headerPath,
      isDesktop = false,
      isNew = false,
      isSignIn = false,
      item,
      label,
      linkClassName,
      logo,
      path,
      url,
      testId,
      variant = "default"
    } = props,
    hasHeader = !headerRegEx.test(variant),
    theme = merge((0, _styles.useTheme)(), customTheme),
    {
      customBackButtonStyles = {},
      customButtonStyles = {},
      customDrawerStyles = {},
      customDrawerPaperStyles = {},
      customFragmentStyles = {},
      customHeadingStyles = {},
      customListStyles = {},
      customListItemStyles = {},
      customLogoStyles = {},
      customMenuButtonStyles = {},
      customParentButtonStyles = {},
      customSignInButtonStyles = {}
    } = bundledStyles,
    buttonId = "navigation-mobile__signin",
    [open, setOpen] = (0, _react.useState)(autoOpen),
    compiledStyles = {
      backButtonStyles: merge(MenuDrawerStyles.BackButtonStyles(theme, variant), customBackButtonStyles),
      drawerStyles: merge(MenuDrawerStyles.DrawerStyles(theme, variant), customDrawerStyles),
      drawerPaperStyles: merge(MenuDrawerStyles.DrawerPaperStyles(theme, isDesktop ? "none" : "block", variant), customDrawerPaperStyles),
      fragmentStyles: merge(MenuDrawerStyles.FragmentStyles(theme, variant), customFragmentStyles),
      headingStyles: merge(MenuDrawerStyles.HeadingStyles(theme, variant), customHeadingStyles),
      listStyles: merge(MenuDrawerStyles.ListStyles(theme, variant), customListStyles),
      listItemStyles: merge(MenuDrawerStyles.ListItemStyles(theme, variant), customListItemStyles),
      menuButtonStyles: merge.all([MenuDrawerStyles.ButtonStyles(theme, variant), customButtonStyles, customMenuButtonStyles]),
      parentButtonStyles: merge.all([MenuDrawerStyles.ButtonStyles(theme, variant), customButtonStyles, customMenuButtonStyles, customParentButtonStyles]),
      signInButtonStyles: merge(MenuDrawerStyles.SignInButtonStyles(theme, variant), customSignInButtonStyles)
    },
    buttonClasses = (0, _classnames.default)({
      "navigation-mobile__drawer-button": true,
      [`${buttonClassName}`]: buttonClassName
    }),
    drawerClasses = (0, _classnames.default)({
      "navigation-mobile__drawer": true,
      [`${drawerClassName}`]: drawerClassName
    }),
    testMap = GetTestIdMap(testId),
    toggleDrawer = (0, _react.useCallback)((e, open) => {
      DrawerMethods.ToggleDrawer(e, open, setOpen);
    }, [setOpen]);
  (0, _react.useEffect)(() => {
    const CloseWatcher = window.PubSub.subscribe("navigation.mobile.close", () => {
      toggleDrawer(null, false);
    });
    return () => {
      window.PubSub.unsubscribe(CloseWatcher);
    };
  }, [anchor, toggleDrawer]);
  (0, _react.useEffect)(() => {
    const handleResize = (0, _debounce.debounce)(() => {
      if (open && isDesktop) {
        toggleDrawer(null, false);
      }
    }, 50);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isDesktop, open, toggleDrawer]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    "data-testid": testMap.componentTestId
  }, /*#__PURE__*/_react.default.createElement(DrawerLink, {
    className: linkClassName,
    label: label,
    path: path,
    item: item,
    url: url,
    isNew: isNew
  }), label && !(0, _string.isStringOfLength)(path) && !(0, _string.isStringOfLength)(url) && (!item || !(0, _string.isStringOfLength)(item.path) && !(0, _string.isStringOfLength)(item.url)) && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: buttonClasses,
    "data-testid": testMap.buttonTestId,
    onClick: e => toggleDrawer(e, true),
    sx: isSignIn ? compiledStyles.signInButtonStyles : compiledStyles.parentButtonStyles
  }, label, isNew === true && /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: "span",
    className: "navigation-mobile__new-indicator"
  }, "New!")), /*#__PURE__*/_react.default.createElement(_material.Drawer, {
    anchor: anchor,
    className: drawerClasses,
    "data-testid": testMap.drawerTestId,
    id: buttonId,
    open: open,
    onClose: () => window.PubSub.publish("navigation.mobile.close"),
    PaperProps: {
      sx: {
        ...compiledStyles.drawerPaperStyles
      }
    },
    sx: compiledStyles.drawerStyles
  }, logo && /*#__PURE__*/_react.default.createElement(_Logo.default, {
    logo: logo,
    customLogoStyles: customLogoStyles
  }), backLabel && /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: "navigation-mobile__back-button",
    "data-testid": testMap.backButtonTestId,
    onClick: e => toggleDrawer(e, false),
    sx: compiledStyles.backButtonStyles
  }, "Back to ", backLabel), hasHeader && /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: "h3",
    className: "navigation-mobile__heading",
    "data-testid": testMap.headingTestId,
    sx: compiledStyles.headingStyles
  }, (0, _string.isStringOfLength)(headerPath) ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: "navigation-mobile__heading-anchor",
    "data-testid": testMap.headingLinkTestId,
    to: headerPath
  }, label, isNew === true && /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: "span",
    className: "navigation-mobile__new-indicator"
  }, "New!")) : /*#__PURE__*/_react.default.createElement(_material.Box, null, label, isNew === true && /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: "span",
    className: "navigation-mobile__new-indicator"
  }, "New!"))), /*#__PURE__*/_react.default.createElement(DrawerList, _extends({}, props, {
    compiledStyles: merge(compiledStyles, {
      parentButtonStyles: compiledStyles.menuButtonStyles
    }),
    testId: testMap.listTestId,
    variant: variant
  })), children)));
};
MenuDrawer.propTypes = {
  /** Window edge which menu draw will be attached to (Default Value: "right") */
  anchor: _propTypes.default.oneOf(["left", "right", "bottom", "top"]),
  /** Boolean to open menu on render (Default Value: false) */
  autoOpen: _propTypes.default.bool,
  /** Label for Back to prior drawer button */
  backLabel: _propTypes.default.string,
  /** Bundled custom style objects (Default Value: {}) */
  bundledStyles: _propTypes.default.shape({
    /** Custom styles object for back to prior level button */
    customBackButtonStyles: _propTypes.default.object,
    /** Custom styles for parent menu button */
    customButtonStyles: _propTypes.default.object,
    /** Custom style object for menu drawer */
    customDrawerStyles: _propTypes.default.object,
    /** Custom style object for Paper block inside drawer */
    customDrawerPaperStyles: _propTypes.default.object,
    /** Custom styles object for all content fragments */
    customFragmentStyles: _propTypes.default.object,
    /** Custom styles object for drawer heading */
    customHeadingStyles: _propTypes.default.object,
    /** Custom style for list of links */
    customListStyles: _propTypes.default.object,
    /** Custom styles for list items */
    customListItemStyles: _propTypes.default.object,
    /** Custom styles for logo image */
    customLogoStyles: _propTypes.default.object,
    /** Custom styles for drawer menu button */
    customMenuButtonStyles: _propTypes.default.object,
    /** Custom button styles from parent drawer menu */
    customParentButtonStyles: _propTypes.default.object,
    /** Custom styles for sign in menu drawer button */
    customSignInButtonStyles: _propTypes.default.object
  }),
  /** Custom class(es) for menu button that opens the drawer */
  buttonClassName: _propTypes.default.string,
  /** Category object decribing child Menu Drawer */
  category: _propTypes.default.shape({
    /** Array of items to display as buttons */
    items: _propTypes.default.array,
    /** Button label */
    label: _propTypes.default.string,
    /** @ignore */
    value: _propTypes.default.string
  }),
  /** Children elements */
  children: _propTypes.default.any,
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Content fragment ID for Menu Drawer */
  fragmentId: _propTypes.default.string,
  /** Interior path for header when selected */
  headerPath: _propTypes.default.string,
  /** Desktop mode indicator */
  isDesktop: _propTypes.default.bool,
  /** Boolean value if MenuDrawer is for signIn (Default Value: false) */
  isSignIn: _propTypes.default.bool,
  /** Item that launches in child menu drawer */
  item: _propTypes.default.shape({
    /** Array of content fragment IDs */
    fragments: _propTypes.default.arrayOf(_propTypes.default.string),
    /** Interior path for header when selected */
    headerPath: _propTypes.default.string,
    /** Button label */
    label: _propTypes.default.string,
    /** Link Path */
    path: _propTypes.default.string,
    /** @ignore */
    value: _propTypes.default.string
  }),
  /** Heading Text */
  label: _propTypes.default.string.isRequired,
  /** Custom link class name */
  linkClassName: _propTypes.default.string,
  /** Object to describe logo image attributes */
  logo: _propTypes.default.shape({
    /** Alt. Description for image */
    alt: _propTypes.default.string.isRequired,
    /** URL for Image */
    src: _propTypes.default.string.isRequired
  }),
  /** Path to internal page */
  path: _propTypes.default.string,
  /** Path to external page */
  url: _propTypes.default.string,
  /** @ignore */
  testId: _propTypes.default.string,
  /** Drawer Style variants */
  variant: _propTypes.default.oneOf(["default", "default--noHeader", "inverse", "inverse--noHeader"])
};
var _default = exports.default = MenuDrawer;